export default __webpack_public_path__ + "static/media/backgroundlogin.4b031c4d.webp";